import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=5c5b6366&"
import script from "./Basic.vue?vue&type=script&lang=js&"
export * from "./Basic.vue?vue&type=script&lang=js&"
import style0 from "./Basic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5b6366')) {
      api.createRecord('5c5b6366', component.options)
    } else {
      api.reload('5c5b6366', component.options)
    }
    module.hot.accept("./Basic.vue?vue&type=template&id=5c5b6366&", function () {
      api.rerender('5c5b6366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/cards/Basic.vue"
export default component.exports